module.exports = __webpack_public_path__ + "static/media/client2.e7f667bd.jpg";